module.exports = __webpack_public_path__ + "img/ml_logo_white.65481123.svg";